import { Component, Input, OnInit } from '@angular/core';
import { IncidentsService } from 'src/app/services/http/incidents/incidents.service';
import { PannesMachine } from 'src/app/model/incidents/pannesList.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IncidentsComponent } from '../incidents/incidents/incidents.component';


@Component({
  selector: 'app-incidents-pannes',
  templateUrl: './incidents-pannes.component.html',
  styleUrls: ['./incidents-pannes.component.scss']
})
export class IncidentsPannesComponent implements OnInit {

  public incident !: any;

  constructor(private service: IncidentsService, private router: Router, private activatedRoute: ActivatedRoute, private incidents: IncidentsComponent) { }

  ngOnInit(): void {

    const params = this.activatedRoute.snapshot.params;
    this.service.getPannesMachineData(params.id).subscribe((incident)=>{
      this.incident = incident;
      // console.log(incident.rg_pannes.length)
      
    })


  }

}
